import { localePrice } from '@/utils/priceLocalization'

const StudentPrice = function ({ studentPrice, quantity }) {
  this.isShowing = Boolean(studentPrice)
  this.formattedAmount = localePrice(
    studentPrice, { hideCurrencyLabel: true, quantity }
  )
}

export default StudentPrice
